module.exports = __webpack_public_path__ + "a35b24510ad55fd6d97affa1a51ad425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic5.png
// module id = 1864
// module chunks = 0